<template>
	<div>
		<div class="topic">
			<div class="topic-pic f-img-box">
				<img :src="data.thumb">
			</div>
			<div class="topic-main">
				<div class="topic-title">{{data.title}}</div>
				<div class="topic-text">{{data.remark}}</div>
				<ul class="topic-items f-cbli">
					<!--<li class="topic-item">
						<div class="topic-item-pic f-img-box">
							<img src="../index/lesson-pic.png">
						</div>
						<div class="topic-item-content">
							<div class="topic-item-title o1">标题标题标题标题标标题标题标题标题标</div>
							<div class="topic-item-text o2">正文正文正文正regh文正文正文正文正文正文正文正文正文正文正文正文正文正文</div>
						</div>
					</li>-->
					<li class="topic-item" @click="$router.push('/lesson-detail/'+item.id)" v-for="item in list">
						<div class="topic-item-pic f-img-box">
							<img :src="item.cover_img">
						</div>
						<div class="topic-item-content">
							<div class="topic-item-title o1">{{item.course_title}}</div>
							<div class="topic-item-text o2">{{tools.HTMLDecode(tools.removeHTML(item.content))}}</div>
						</div>
					</li>

				</ul>
			</div>
		</div>
		<!--<div class="topic-enroll">报名学习</div>-->
	</div>
</template>

<script>
	export default{
		data(){
			return{
				data:{},
				list:[]
			}
		},
		created(){
			this.$api.get("",{
				api:"/v1/special_subject/read_spe",
				id:this.$route.params.id
			},res=>{
				var data=res.data;
				this.data=data.spe;
				this.list=data.spe_mk;
			})
		}
	}
</script>

<style>
	.topic{
		padding-bottom: 1.733rem;
	}
	.topic-pic{
		height:4.24rem;
	}
	.topic-main{
		padding:0 0.4rem;
	}
	.topic-title{
		margin-top:0.24rem;
		color:#333;
		font-size:0.64rem;
		line-height:0.96rem;
	}
	.topic-text{
		font-size: 0.346rem;
		color:#666;
		line-height:0.52rem;
	}
	.topic-items{
		padding-top:0.133rem;
		margin-top:0.453rem;
		border-top:1px solid #e6e6e6;
	}
	.topic-item{
		margin-top:0.4rem;
	}
	.topic-item-pic{
		float:left;
		width:2.88rem;
		height:2.106rem;
		border-radius: 0.133rem;
	}
	.topic-item-content{
		float:right;
		width:6.066rem;
		padding-top:0.093rem;
	}
	.topic-item-title{
		font-size: 0.426rem;
		line-height:0.64rem;
		color:#333;
	}
	.topic-item-text{
		margin-top:0.2rem;
		font-size: 0.346rem;
		line-height:0.52rem;
		color:#666;
	}
	.topic-enroll{
		position: fixed;
		bottom:0;
		left:0;
		height:1.306rem;
		width:100%;
		line-height:1.306rem;
		text-align: center;
		color:#fff;
		background:#ec6d3a;
		font-size: 0.4rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/topic/topic.vue